import React from 'react'
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native'
import { createNativeStackNavigator, NativeStackNavigationProp } from '@react-navigation/native-stack'
import { Platform } from 'react-native'
import {
  Menu,
  QRCode,
  QRCodeScanner,
  Settings,
  Subscription,
  Birthdays,
  MapScreen,
  GraphScreen,
  NearbyScreen,
  ImportContacts,
  ClassifyContacts,
  MergeContacts,
  LegalNotice,
  ContactUs,
  PrivacyPolicy,
  JoinUs,
} from '@screens'

// Import des Stack Navigators séparés
import CategoriesStackNavigator from './CategoriesStackNavigator'
import HashtagsStackNavigator from './HashtagsStackNavigator'
import CalendarStackNavigator from './CalendarStackNavigator'
import KeepContactStackNavigator from './KeepContactStackNavigator'
import NotesStackNavigator from './NotesStackNavigator'
import ScheduledMessagesStackNavigator from './ScheduledMessagesStackNavigator'
import RelationalColorsStackNavigator from './RelationalColorsStackNavigator'

export type ScreenMenuProps<RouteName extends keyof MenuStackParamList> = {
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<MenuStackParamList, RouteName>,
    NativeStackNavigationProp<MenuStackParamList, keyof MenuStackParamList>
  >
  route: RouteProp<MenuStackParamList, RouteName>
}

export type MenuStackParamList = {
  MenuMain: undefined
  
  // Stack Navigators pour chaque section
  ImportContacts: undefined
  ClassifyContacts: undefined
  MergeContacts: undefined
  Map: undefined
  Graph: undefined
  Nearby: undefined
  Birthdays: undefined
  Calendar: undefined
  Categories: undefined
  Hashtags: undefined
  RelationalColors: undefined
  KeepContact: undefined
  Notes: undefined
  ScheduledMessages: undefined
  
  // Settings et autres
  QRCode: undefined
  Scan: undefined
  Settings: undefined
  Subscription: undefined

  // Footer pages
  LegalNotice: undefined
  ContactUs: undefined
  PrivacyPolicy: undefined
  JoinUs: undefined
}

const MenuStack = createNativeStackNavigator<MenuStackParamList>()

export const MenuNavigator = () => {
  const initialRoute = 'MenuMain'

  return (
    <MenuStack.Navigator 
      screenOptions={{ headerShown: false }}
      initialRouteName={initialRoute}
    >
        <MenuStack.Screen name="MenuMain" component={Menu} />
        
        {/* Stack Navigators pour chaque section */}
        <MenuStack.Screen name="ImportContacts" component={ImportContacts} />
        <MenuStack.Screen name="ClassifyContacts" component={ClassifyContacts} />
        <MenuStack.Screen name="MergeContacts" component={MergeContacts} />
        <MenuStack.Screen name="Map" component={MapScreen} />
        <MenuStack.Screen name="Graph" component={GraphScreen} />
        <MenuStack.Screen name="Nearby" component={NearbyScreen} />
        <MenuStack.Screen name="Birthdays" component={Birthdays} />
        <MenuStack.Screen name="Calendar" component={CalendarStackNavigator} />
        <MenuStack.Screen name="Categories" component={CategoriesStackNavigator} />
        <MenuStack.Screen name="Hashtags" component={HashtagsStackNavigator} />
        <MenuStack.Screen name="RelationalColors" component={RelationalColorsStackNavigator} />
        <MenuStack.Screen name="KeepContact" component={KeepContactStackNavigator} />
        <MenuStack.Screen name="Notes" component={NotesStackNavigator} />
        <MenuStack.Screen name="ScheduledMessages" component={ScheduledMessagesStackNavigator} />
        
        {/* Settings et autres */}
        <MenuStack.Screen name="QRCode" component={QRCode} />
        <MenuStack.Screen name="Scan" component={QRCodeScanner} />
        <MenuStack.Screen name="Settings" component={Settings} />
        <MenuStack.Screen name="Subscription" component={Subscription} />

        {/* Footer pages */}
        <MenuStack.Screen name="LegalNotice" component={LegalNotice} />
        <MenuStack.Screen name="ContactUs" component={ContactUs} />
        <MenuStack.Screen name="PrivacyPolicy" component={PrivacyPolicy} />
        <MenuStack.Screen name="JoinUs" component={JoinUs} />
    </MenuStack.Navigator>
  )
} 